import { RefObject, useState, useMemo, useEffect } from 'react'

export default function useOnScreen (ref: RefObject<HTMLElement>) {
    const [isIntersecting, setIntersecting] = useState(false)

    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])

    useEffect(() => {
        const currentRef = ref.current
        if (!currentRef) {
            return
        }
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])

    return isIntersecting
}
